import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = { class: "flex flex-row space-x-4 md:flex-col md:space-x-0 md:space-y-4" }
const _hoisted_3 = { class: "flex flex-col items-start md:flex-row md:items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "minimumDrinks",
  class: "mr-4 text-white"
}, "Minimum", -1)
const _hoisted_5 = { class: "flex flex-col items-start md:flex-row md:items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "maximumDrinks",
  class: "mr-4 text-white"
}, "Maximum", -1)
const _hoisted_7 = { key: 1 }

import PrimaryLabel from "@/components/Form/Common/PrimaryLabel.vue";
import { useGameStore } from "@/Store/useGameStore";
import { computed, ComputedRef, ref, watch } from "vue";
import ErrorText from "@/components/Texts/ErrorText.vue";
import InputNumber from "@/components/Form/Common/InputNumber.vue";
import { GameStates } from "@/Interfaces/GameStates";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditNumberDrinks',
  props: {
    displayErrors: { type: Boolean }
  },
  setup(__props: any) {

const gameStore = useGameStore();

const props = __props;

const minimumDrinks = ref(gameStore.minimumDrinks);
const maximumDrinks = ref(gameStore.maximumDrinks);

const errors: ComputedRef<string[]> = computed(() => {
  return gameStore.errors;
});

const inGame: ComputedRef<GameStates> = computed(() => {
  return gameStore.inGame;
});

watch(
  () => minimumDrinks,
  () => {
    if (inGame.value === GameStates.Started) {
      gameStore.updateMinimumAndMaximumDrinksWithVerification(
        minimumDrinks.value,
        maximumDrinks.value
      );
    } else {
      gameStore.updateMinimumDrinks(minimumDrinks.value);
    }
  },
  { deep: true }
);

watch(
  () => maximumDrinks,
  () => {
    if (inGame.value === GameStates.Started) {
      gameStore.updateMinimumAndMaximumDrinksWithVerification(
        minimumDrinks.value,
        maximumDrinks.value
      );
    } else {
      gameStore.updateMaximumDrinks(maximumDrinks.value);
    }
  },
  { deep: true }
);

const errorMinimumAndMaximumDrinks = computed(() => {
  return gameStore.errors.find((error) =>
    error.path.includes("errorMinimumAndMaximumDrinks")
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PrimaryLabel, {
      text: "Nombre de gorgées",
      class: "mb-2 text-left"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(InputNumber, {
          id: "minimumDrinks",
          name: "minimumDrinks",
          placeholder: "1",
          is_required: true,
          modelValue: minimumDrinks.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((minimumDrinks).value = $event)),
          modelModifiers: { number: true }
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(InputNumber, {
          id: "maximumDrinks",
          name: "maximumDrinks",
          placeholder: "5",
          is_required: true,
          modelValue: maximumDrinks.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((maximumDrinks).value = $event)),
          modelModifiers: { number: true }
        }, null, 8, ["modelValue"])
      ])
    ]),
    (errorMinimumAndMaximumDrinks.value)
      ? (_openBlock(), _createBlock(ErrorText, {
          key: 0,
          text: errorMinimumAndMaximumDrinks.value.message,
          class: "mt-2 text-left"
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (props.displayErrors)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(ErrorText, {
                text: error.message,
                class: "mt-2"
              }, null, 8, ["text"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})